<p [innerHtml]="'terms-and-conditions.updated-content' | translate"></p>

<obg-content-section-group-container
	*ngIf="!isHistoryEnabled else termsAndConditionsHistory"
	class="obg-m-latest-terms-and-conditions-content"
	test-id="latest-terms-and-conditions-container"
	data-test-id="latest-terms-and-conditions-container"
	hideBanner
	document="terms-and-conditions"
></obg-content-section-group-container>

<div *ngIf="showError" class="obg-m-latest-terms-and-conditions-error">
	{{ 'terms-and-conditions.update-error' | translate }}
</div>

<div class="obg-m-latest-terms-and-conditions-actions">
	<button
		data-test-id="latest-terms-and-conditions-close"
		test-id="latest-terms-and-conditions-close"
		color="primary"
		(click)="closeModal()"
		mat-flat-button
	>
		{{ 'general.cancel' | translate }}
	</button>
	<button
		data-test-id="latest-terms-and-conditions-accept"
		test-id="latest-terms-and-conditions-accept"
		color="accent"
		(click)="accept()"
		mat-flat-button
	>
		{{ 'general.accept' | translate }}
	</button>
</div>

<ng-template #termsAndConditionsHistory>
	<obg-content-section-group-container
		*ngIf="resourceKeys$ | async as resourceKeys"
		class="obg-m-latest-terms-and-conditions-content"
		document="terms-and-conditions"
		[keysToBeUsedWithinDocumentType]="resourceKeys"
		[hideBanner]="true"
	></obg-content-section-group-container>
</ng-template>
